/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { DsFormExcel } from '../models/ds-form-excel';

@Injectable({
  providedIn: 'root',
})
export class DsOrganisationFormExcelService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Send an object to roazhon containing form template data, get item14 if no error.
   *
   * @param organisationId Organisation ID
   * @param body Excel data as an object
   * @returns Observable type `<DsFormExcel>`
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public organisationGenerateFormDataFromExcel(organisationId: number, body: any): Observable<DsFormExcel> {
    this.path = `/organisations/${organisationId}/forms/excelimport`;
    return this.postModel<DsFormExcel>({ body });
  }

  /**
   * Create DsFormExcel instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormExcel` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsFormExcel {
    return new DsFormExcel(jsonObject);
  }
}
